import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get } from "../../../service/api";
import { IFaqSectionDto } from "../interface/dto/faq.dto";

export const fetchFaqSections = (
    tokens: ITokenPair,
): Observable<Array<IFaqSectionDto>> =>
    get<Array<IFaqSectionDto>>("/content/faq", undefined, tokens);
